import React, { Suspense } from "react";
import { loadAnalytics } from "../helpers/segment";

/**
 * As more 3rd party scripts and APIs are needed, they should be added here,
 * lazily.
 */
const LazyDatadog = React.lazy<React.FC<React.PropsWithChildren>>(
  () => import("./DataDog"),
);

const LazySegment = React.lazy<React.FC<React.PropsWithChildren>>(
  () => import("./Segment"),
);

/**
 * Eagerly load the Segment analytics library so that any track() calls made
 * by children while the lazy Segment component is still loading are buffered
 * by @segment/analytics-next. This avoids anonymous events during the brief
 * window before the Segment component mounts and calls identify().
 */
loadAnalytics();

/**
 * This wrapper component will try lazy loading all these chunks (rollup
 * handles the chunking because we use the `import` function). But we don't put
 * a loading indicator in the suspense fallback, because we still want the app
 * to function While these chunks are loading. So, react suspense will just
 * render the children without wrapping them in the providers until the chunks
 * are downloaded.
 *
 * This means you cannot use any Datadog features until the chunks created by
 * this React.lazy boundary are downloaded and parsed. So always check to see
 * if the libraries in this wrapper are really loaded.
 */
export const ThirdParty = (props?: React.PropsWithChildren) => {
  return (
    <Suspense fallback={props?.children}>
      <LazyDatadog />
      <LazySegment>{props?.children}</LazySegment>
    </Suspense>
  );
};
